exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.printer[data-v-4516a6f6] {\n  height: 60px;\n  border-radius: 4px;\n  background-color: #000000;\n  border: solid 1px #000000;\n  color: #ffffff;\n}\n.no-print[data-v-4516a6f6] {\n  height: 60px;\n  border-radius: 4px;\n  background-color: #ffffff;\n  border: solid 1px #000000;\n}\n.btn-checkout[data-v-4516a6f6] {\n  border: 2px solid #000000;\n  border-radius: 25px;\n}\n.body-box[data-v-4516a6f6] {\n  border-radius: 4px;\n}\n.receive[data-v-4516a6f6] {\n  margin-bottom: 5px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4516a6f6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/check-out/components/SelectPrinter.vue
// module id = 492
// module chunks = 1